import React from 'react'
import {
  Modal, ModalHeader, ModalBody, ModalFooter, Button, Row, Col,
} from 'reactstrap'
import moment from 'moment'
import { FICHA_PJ_STATUS } from './fichaPjApi'

const BOOL_LABEL = (v) => (v === 1 || v === true ? 'Sim' : v === 0 || v === false ? 'Não' : '—')

const formatDate = (v) => (v ? moment(v).format('DD/MM/YYYY') : '—')

const parseJsonList = (v) => {
  if (!v) return '—'
  try {
    const arr = typeof v === 'string' ? JSON.parse(v) : v
    return Array.isArray(arr) && arr.length ? arr.join(', ') : '—'
  } catch (e) {
    return String(v)
  }
}

const Field = ({ label, value }) => (
  <Col md={6} className="mb-2">
    <div style={{ fontSize: '0.75rem', color: '#74788d' }}>{label}</div>
    <div style={{ fontSize: '0.9rem', color: '#273351' }}>{value || '—'}</div>
  </Col>
)

const Section = ({ title, children }) => (
  <div className="mb-3">
    <h6 style={{ color: '#273351', borderBottom: '1px solid #e9ecef', paddingBottom: 6, marginBottom: 12 }}>
      {title}
    </h6>
    <Row>{children}</Row>
  </div>
)

const FichaPjDetailModal = ({ isOpen, toggle, ficha }) => {
  if (!ficha) return null

  const f = ficha
  const status = f.fichaPj_status || FICHA_PJ_STATUS.NAO_REVISADO
  const isAprovado = status === FICHA_PJ_STATUS.APROVADO

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg" scrollable>
      <ModalHeader toggle={toggle}>
        Ficha cadastral — {f.pf_nomeExibicao || f.fichaPj_razaoSocial || 'Prestador'}
      </ModalHeader>
      <ModalBody>
        <div className="mb-3">
          <span
            style={{
              display: 'inline-block',
              padding: '4px 10px',
              borderRadius: 4,
              fontSize: 12,
              fontWeight: 600,
              color: isAprovado ? '#34c38f' : '#f46a6a',
              border: `2px solid ${isAprovado ? '#34c38f' : '#f46a6a'}`,
              backgroundColor: isAprovado ? '#e8f8f0' : '#fdecea',
            }}
          >
            {status}
          </span>
          {f.fichaPj_dtCria && (
            <span className="text-muted ml-2" style={{ fontSize: '0.85rem' }}>
              Enviado em {moment(f.fichaPj_dtCria).format('DD/MM/YYYY HH:mm')}
            </span>
          )}
        </div>

        <Section title="Dados cadastrais">
          <Field label="Razão Social" value={f.fichaPj_razaoSocial} />
          <Field label="CNPJ" value={f.fichaPj_cnpj} />
          <Field label="Nome Fantasia" value={f.fichaPj_nomeFantasia} />
          <Field label="Data de abertura" value={formatDate(f.fichaPj_dtAbertura)} />
          <Field label="Inscrição Municipal" value={f.fichaPj_inscMunicipal} />
          <Field
            label="Inscrição Estadual"
            value={f.fichaPj_inscEstadualIsento ? 'Isento' : f.fichaPj_inscEstadual}
          />
        </Section>

        <Section title="Contato">
          <Field label="Endereço" value={`${f.fichaPj_endereco || ''} ${f.fichaPj_numero || ''} ${f.fichaPj_complemento || ''}`.trim()} />
          <Field label="Bairro" value={f.fichaPj_bairro} />
          <Field label="Cidade / UF" value={`${f.fichaPj_cidade || ''}/${f.fichaPj_estado || ''}`} />
          <Field label="CEP" value={f.fichaPj_cep} />
          <Field label="Telefone" value={f.fichaPj_telefone} />
          <Field label="Celular" value={f.fichaPj_celular} />
          <Field label="Telefone comercial" value={f.fichaPj_telComercial} />
          <Field label="E-mail" value={f.fichaPj_email} />
          <Col md={12} className="mb-2">
            <div style={{ fontSize: '0.75rem', color: '#74788d' }}>Observação</div>
            <div style={{ fontSize: '0.9rem', color: '#273351' }}>{f.fichaPj_obs || '—'}</div>
          </Col>
        </Section>

        <Section title="Serviço e empresa">
          <Col md={12} className="mb-2">
            <div style={{ fontSize: '0.75rem', color: '#74788d' }}>Tipo de serviço</div>
            <div style={{ fontSize: '0.9rem', color: '#273351' }}>{f.fichaPj_tipoServico || '—'}</div>
          </Col>
          <Field label="Porte" value={f.fichaPj_porte} />
          <Field label="Ramo" value={f.fichaPj_ramo} />
          <Field label="Optante Simples" value={BOOL_LABEL(f.fichaPj_optanteSimples)} />
        </Section>

        <Section title="Dados bancários">
          <Field label="Banco" value={f.fichaPj_banco} />
          <Field label="Agência" value={f.fichaPj_agencia} />
          <Field label="Conta" value={f.fichaPj_contaNum} />
          <Field label="Tipo da conta" value={f.fichaPj_contaTp} />
        </Section>

        <Section title="Estrutura alocada">
          <Col md={12} className="mb-2">
            <div style={{ fontSize: '0.9rem', color: '#273351' }}>{parseJsonList(f.fichaPj_estrutura)}</div>
          </Col>
        </Section>

        <Section title="Informações complementares">
          <Field label="Possui contador" value={BOOL_LABEL(f.fichaPj_possuiContador)} />
          <Field label="Possui colaboradores/sócios/terceiros" value={BOOL_LABEL(f.fichaPj_possuiColaboradores)} />
          <Field
            label="Faturamento médio mensal"
            value={f.fichaPj_faturamentoMedio != null
              ? Number(f.fichaPj_faturamentoMedio).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
              : '—'}
          />
          <Field label="Nº de clientes ativos" value={f.fichaPj_numClientes} />
        </Section>

        <Section title="Representante legal">
          <Field label="Nome" value={f.fichaPj_repNome} />
          <Field label="Data de nascimento" value={formatDate(f.fichaPj_repDtNasc)} />
          <Field label="CPF" value={f.fichaPj_repCpf} />
          <Field label="Formação" value={f.fichaPj_repFormacao} />
          <Field label="Celular" value={f.fichaPj_repCelular} />
          <Field label="WhatsApp" value={f.fichaPj_repWhatsapp} />
          <Field label="Endereço" value={f.fichaPj_repEndereco} />
          <Field label="Bairro" value={f.fichaPj_repBairro} />
          <Field label="Cidade / UF" value={`${f.fichaPj_repCidade || ''}/${f.fichaPj_repUf || ''}`} />
          <Field label="CEP" value={f.fichaPj_repCep} />
          <Field label="E-mail" value={f.fichaPj_repEmail} />
          <Field label="Telefone" value={f.fichaPj_repTelefone} />
        </Section>

        <Section title="Documentos e declaração">
          <Col md={12} className="mb-2">
            <div style={{ fontSize: '0.75rem', color: '#74788d' }}>Documentos marcados</div>
            <div style={{ fontSize: '0.9rem', color: '#273351' }}>{parseJsonList(f.fichaPj_documentos)}</div>
          </Col>
          <Field label="Declaração de veracidade" value={BOOL_LABEL(f.fichaPj_declaracaoVerdadeira)} />
          <Field label="Nome para assinatura" value={f.fichaPj_repAssinaturaNome} />
        </Section>

        <Col md={12}>
          <div className="alert alert-light border mb-0" style={{ fontSize: '0.85rem' }}>
            Anexos de arquivos ainda não estão disponíveis neste formulário.
          </div>
        </Col>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>Fechar</Button>
      </ModalFooter>
    </Modal>
  )
}

export default FichaPjDetailModal
